<template>
    <div v-if="visible" class="confirmation-dialog-overlay">
      <div class="confirmation-dialog">
        <h3>{{ title }}</h3>
        <p>Olet perumassa kuukausittaista tilaustasi kampanjalle  <b>{{ selectedSub }}</b> </p>
        <p>Uuden kuukausilahjoituksen voit aloittaa uudella tilauksella.</p>
        <p>{{ message }}</p>
        <div class="confirmation-dialog-actions">
          <div v-if="loading" style="pointer-events: none" class="spinner"></div>
          <button :disabled="isButtonDisabled" @click="confirmAction" class="btn btn-danger">Vahvista</button>
          <button @click="cancelAction" class="btn btn-secondary">Peruuta</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "confirmation-dialog",
    props: {
      visible: { type: Boolean, required: true },
      title: { type: String, default: "Vahvista toiminto" },
      message: { type: String, default: "Oletko varma, että haluat jatkaa?" },
      selectedSub: {type: String, default: "default kampanja"}
    },
    data() {
      return {
        isButtonDisabled: false,
        loading: false
      };
    },
    methods: {
      confirmAction() {
        this.loading = true;
        this.isButtonDisabled = true;
        this.$emit("confirm");
      },
      cancelAction() {
        this.$emit("cancel");
      },
    },
  };
  </script>
  
  <style>
  .confirmation-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .confirmation-dialog {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    max-width: 400px;
    width: 100%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  .confirmation-dialog-actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    justify-content: center;
  }
  </style>
  